import { MouseEventHandler } from "react";
import { Link } from "react-router-dom";

import dfbird_icon from "./../../img/dfbird/icon.png";
import dfbird_screen from "./../../img/dfbird/screen.png";
import { DETAIL_DF_BIRD_ROUTE } from "../../consts/routes";
import { PRODUCT_TYPE_ID_DF_BIRD } from "../../consts/constants";
import { Trans, useTranslation } from "react-i18next";
import i18n from "../../i18n/configs";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

type PanelProps = {
    handleSelectProduct: MouseEventHandler<HTMLButtonElement>;
    handleSelectQuote: MouseEventHandler<HTMLButtonElement>;
    handleSelectProductAsFreeTrial: MouseEventHandler<HTMLButtonElement>;
};

/**
 * DF BIRD 商品パネル
 * @returns JSX.Element
 */
const DfBirdPanel: React.FC<PanelProps> = ({
    handleSelectProduct,
    handleSelectQuote,
    handleSelectProductAsFreeTrial,
}) => {
    const { t } = useTranslation();

    return (
        <div className="flex h-full w-full max-w-sm flex-col justify-between rounded-lg border border-gray-300 bg-white px-6 py-4 shadow-lg">
            <div className="flex items-center justify-center">
                <img className="h-20 w-20 p-3" src={dfbird_icon} alt="dfbird" />
                <div>
                    <label className="text-4xl font-semibold tracking-tight text-lime-900">DF BIRD</label>
                </div>
            </div>
            <img className="px-12 py-2" src={dfbird_screen} alt="dfbird" />
            {i18n.language === "ja" ? (
                <div className="pb-5">
                    <div className="ml-4 space-y-1 pt-2 text-sm  font-bold text-gray-700">
                        <div className="flex items-end gap-2">
                            <span className="w-36">{t("ProductSelect.priceForWithDfscanner")}</span>
                            <span className="flex items-end gap-1">
                                <span className="text-2xl leading-none">無料</span>
                            </span>
                        </div>
                        <div className="flex items-end gap-2">
                            <span className="w-20">{t("ProductSelect.priceForIndividual")}</span>
                            <span className="flex items-end gap-1">
                                <span className="text-2xl leading-none">5</span>
                                <span className="text-xs">{t("ProductSelect.manyenPerYear")}</span>
                            </span>
                        </div>
                        <p className="text-xs text-gray-500">{t("ProductSelect.excludingTax")}</p>
                    </div>
                </div>
            ) : (
                <div className="ml-4 pb-6 pt-2 text-sm font-bold text-lime-700">
                    <p className="">* If you would like to purchase outside of Japan, please contact us for a quote.</p>
                </div>
            )}
            <ul className="ml-2 space-y-1 text-sm text-gray-900">
                <li className="flex items-start gap-2">
                    <CheckCircleIcon fontSize="small" className="mt-0.5 text-lime-500" />
                    <span>{t("ProductSelect.dfbirdText1")}</span>
                </li>
                <li className="flex items-start gap-2">
                    <CheckCircleIcon fontSize="small" className="mt-0.5 text-lime-500" />
                    <span>{t("ProductSelect.dfbirdText2")}</span>
                </li>
            </ul>

            <p className="mt-2 text-center text-sm font-bold text-lime-800">
                <Trans
                    i18nKey="ProductSelect.softwareDetail"
                    components={{
                        l: (
                            <a
                                className="link-text"
                                href={
                                    i18n.language === "ja"
                                        ? "https://deepforest-tech.co.jp/df-bird/"
                                        : "https://deepforest-tech.co.jp/en/df-bird/"
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                            />
                        ),
                    }}
                />
            </p>
            <div className="flex flex-col items-center justify-center gap-3 pb-4 pt-4">
                {/* クレジット購入ボタンは非表示にしておく */}
                {/* <button
                    id="purchase-dflat-btn"
                    onClick={handleSelectProduct}
                    className="text-lx btn-green-white h-full w-2/3"
                    value={PRODUCT_TYPE_ID_DF_LAT_LITE}
                >
                    {t("ProductSelect.purcahseLicense")}
                </button> */}
                <button
                    id="quote-dfscanner-btn"
                    onClick={handleSelectQuote}
                    className="text-lx btn-green-white h-full w-2/3 py-1.5"
                    value={PRODUCT_TYPE_ID_DF_BIRD}
                >
                    {t("ProductSelect.requestQuote")}
                </button>
                <button
                    id="trial-dflat-btn"
                    onClick={handleSelectProductAsFreeTrial}
                    className="text-lx btn-white h-full w-2/3 py-1.5"
                    value={PRODUCT_TYPE_ID_DF_BIRD}
                >
                    {t("ProductSelect.tryFreeTrial")}
                </button>
            </div>
        </div>
    );
};

export default DfBirdPanel;
